import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { IUsuario } from '@/types/firestore.types';

/**
 * Hook personalizado para acessar o contexto de autenticação da aplicação.
 *
 * Este hook fornece acesso ao estado do usuário autenticado e às funções
 * de autenticação (login, cadastro, logout) disponibilizadas pelo AuthProvider.
 *
 * Ele garante que o componente que o utiliza esteja aninhado dentro de um AuthProvider,
 * lançando um erro caso contrário, para evitar comportamentos inesperados e
 * promover um uso correto da arquitetura de contexto.
 *
 * @returns Um objeto contendo o usuário autenticado (ou null) e as funções de autenticação.
 * @throws {Error} Se o hook for utilizado fora de um AuthProvider.
 */

interface AuthContextType {
  usuario: IUsuario | null;
  login: (email: string, senha: string) => Promise<void>;
  cadastro: (email: string, senha: string, tipo_usuario: string, unidade_id?: string) => Promise<void>;
  logout: () => Promise<void>;
  carregandoAutenticacao: boolean;
  erroAutenticacao: string | null;
  limparErro: () => void;
}

export const useAuth = (): AuthContextType => {
  const contexto = useContext(AuthContext);

  if (!contexto) {
    throw new Error('useAuth deve ser utilizado dentro de um AuthProvider.');
  }

  return contexto;
};